import { FC } from "react";
import { ResponsivePie } from "@nivo/pie";
import clsx from "clsx";
import numeral from "numeral";

interface PieProps {
  data: {
    id: string;
    label: string;
    value: number;
    color: string;
    bgColor: string;
  }[];
  innerRadius?: number;
}

const Pie: FC<PieProps> = ({ data, innerRadius = 0.6 }) => (
  <ResponsivePie
    data={data}
    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
    innerRadius={innerRadius}
    padAngle={0.5}
    cornerRadius={3}
    activeOuterRadiusOffset={8}
    borderWidth={1}
    borderColor={{
      from: "color",
      modifiers: [["darker", 0.2]],
    }}
    colors={{ datum: "data.color" }}
    enableArcLinkLabels={false}
    arcLabelsSkipAngle={10}
    enableArcLabels={true}
    arcLabelsTextColor="#ffffff"
    arcLabel={(e) => numeral(e.value).format("0.0a")}
    tooltip={({
      datum: {
        formattedValue,
        data: { bgColor, label, color, value },
      },
    }) => (
      <div
        style={{
          padding: "10px 14px",
          background: "white",
          color: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: 1.4,
          whiteSpace: "nowrap",
          pointerEvents: "none", // makes sure it doesn't block hover
          transform: "translateY(-4px)", // subtle lift
        }}
        className={bgColor}
      >
        <div className={clsx("mb-1 opacity-85 text-black")} style={{ color }}>
          {label}
        </div>
        <div className="text-lg font-600 text-black">
          {numeral(value).format("0,0")}
        </div>
      </div>
    )}
    motionConfig="gentle"
    transitionMode="pushIn"
    animate={true}
  />
);

export default Pie;
